var React = require('react');

function Layouts (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.85,53.67 C51.66,51.05 58,43.98 58,30.96 C58,17.94 43.75,0 29,0 C14.24,0 0,16.42 0,29.45 C0,42.47 10.04,56.29 30.85,53.67 Z","id":"Oval","fill":"#D1FDFF","key":0}),React.createElement("g",{"id":"layout","transform":"translate(20.000000, 18.000000)","stroke":"#0065AD","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"18","height":"18","rx":"2","key":0}),React.createElement("line",{"x1":"0","y1":"6","x2":"18","y2":"6","id":"Path","key":1}),React.createElement("line",{"x1":"6","y1":"18","x2":"6","y2":"6","id":"Path","key":2})])]);
}

Layouts.defaultProps = {"width":"58px","height":"54px","viewBox":"0 0 58 54","version":"1.1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = Layouts;

Layouts.default = Layouts;
